import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { validarPermissao } from 'src/app/core/utils/permissionScreen/permissionScreen';
import {
  IOpcaoAcao,
  IOpcaoTela
} from 'src/app/core/utils/permissionScreen/permissionScreen.types';
import { ModuloService } from 'src/app/services/ModuloService/modulo.service';
import { BRAND } from 'src/app/core/constants/brand';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  readonly brand = BRAND;

  constructor(private router: Router, private moduloService: ModuloService) {}

  useNavigate(route: string) {
    this.router.navigate([route]);
  }

  viewMenu(menu: IOpcaoTela, acao: IOpcaoAcao): boolean {
    return validarPermissao(menu, acao);
  }

  isModuloAtivo(modulo: string) {
    return this.moduloService.isModuloAtivo(modulo);
  } 
}
